import React from "react";

const DashboardIcon = ({ color ="#464646" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1301_5121)">
        <path
          d="M19.0664 12.9471H18.6797V8.56079C18.6797 8.34722 18.5065 8.17407 18.293 8.17407H16.4784C16.2648 8.17407 16.0917 8.34722 16.0917 8.56079V12.9471H15.3183V9.59614C15.3183 9.38257 15.1451 9.20942 14.9315 9.20942H13.117C12.9034 9.20942 12.7302 9.38257 12.7302 9.59614V12.9471H11.9568V10.6315C11.9568 10.4179 11.7837 10.2447 11.5701 10.2447H9.75552C9.54195 10.2447 9.3688 10.4179 9.3688 10.6315V12.9471H8.98209C8.76851 12.9471 8.59537 13.1203 8.59537 13.3338C8.59537 13.5474 8.76851 13.7206 8.98209 13.7206H19.0664C19.28 13.7206 19.4531 13.5474 19.4531 13.3338C19.4531 13.1203 19.28 12.9471 19.0664 12.9471ZM16.8651 8.94751H17.9063V12.9471H16.8651V8.94751ZM13.5037 9.98286H14.5448V12.9471H13.5037V9.98286ZM10.1422 11.0182H11.1833V12.9471H10.1422V11.0182Z"
          fill={color}
        />
        <path
          d="M11.2948 9.40107C11.3937 9.40107 11.4927 9.36331 11.5682 9.28779L13.6965 7.15947L14.8063 8.26928C14.9574 8.42031 15.2022 8.42031 15.3532 8.26928L16.9989 6.62358V6.676C16.9989 6.88957 17.1721 7.06272 17.3857 7.06272C17.5992 7.06272 17.7724 6.88957 17.7724 6.676V5.68997C17.7724 5.4764 17.5992 5.30325 17.3857 5.30325H16.3996C16.186 5.30325 16.0129 5.4764 16.0129 5.68997C16.0129 5.90355 16.186 6.07669 16.3996 6.07669H16.452L15.0798 7.44894L13.97 6.33913C13.819 6.18814 13.5741 6.1881 13.4231 6.33913L11.0213 8.7409C10.8703 8.89193 10.8703 9.1368 11.0213 9.28783C11.0969 9.36331 11.1958 9.4011 11.2948 9.40107Z"
          fill={color}
        />
        <path
          d="M19.5586 3.75638H4.44141C3.64663 3.75638 3 4.40301 3 5.19778V16.1464C3 16.9411 3.64663 17.5878 4.44141 17.5878H10.2179L9.4414 19.4702H7.37685C7.16327 19.4702 6.99013 19.6433 6.99013 19.8569C6.99013 20.0705 7.16327 20.2436 7.37685 20.2436H16.6232C16.8368 20.2436 17.0099 20.0705 17.0099 19.8569C17.0099 19.6433 16.8368 19.4702 16.6232 19.4702H14.5587L13.7822 17.5878H19.5586C20.3534 17.5878 21 16.9411 21 16.1464V5.19778C21 4.40301 20.3534 3.75638 19.5586 3.75638ZM10.278 19.4702L11.054 17.5889H12.946L13.722 19.4702H10.278ZM4.44141 4.52982H19.5586C19.9269 4.52982 20.2266 4.82945 20.2266 5.19778V14.494H3.77344V5.19778C3.77344 4.82949 4.07307 4.52982 4.44141 4.52982ZM19.5586 16.8143H4.44141C4.07307 16.8143 3.77344 16.5147 3.77344 16.1464V15.2674H20.2266V16.1464C20.2266 16.5147 19.9269 16.8143 19.5586 16.8143Z"
          fill={color}
        />
        <path
          d="M4.93359 13.7206H7.43517C7.64875 13.7206 7.82189 13.5474 7.82189 13.3339C7.82189 13.1203 7.64875 12.9471 7.43517 12.9471H4.93359C4.72002 12.9471 4.54688 13.1203 4.54688 13.3339C4.54688 13.5474 4.72002 13.7206 4.93359 13.7206Z"
          fill={color}
        />
        <path
          d="M4.93359 12.1737H6.73205C6.94562 12.1737 7.11877 12.0006 7.11877 11.787C7.11877 11.5734 6.94562 11.4003 6.73205 11.4003H4.93359C4.72002 11.4003 4.54688 11.5734 4.54688 11.787C4.54688 12.0006 4.72002 12.1737 4.93359 12.1737Z"
          fill={color}
        />
        <path
          d="M4.93359 7.62357H8.98802C9.2016 7.62357 9.37474 7.45042 9.37474 7.23685V5.68997C9.37474 5.4764 9.2016 5.30325 8.98802 5.30325H4.93359C4.72002 5.30325 4.54688 5.4764 4.54688 5.68997V7.23685C4.54688 7.45042 4.72002 7.62357 4.93359 7.62357ZM5.32031 6.07669H8.60131V6.85013H5.32031V6.07669Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1301_5121">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(3 3)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DashboardIcon;
